import { Injectable } from '@angular/core';
import { concat, Observable } from 'rxjs';
import { first, tap } from 'rxjs/operators';

import { StreetTypeApiRepository } from '../repositories/street-type-api.repository';
import { StreetTypeCacheRepository } from '../repositories/street-type-cache.repository';
import { StreetTypeInterface } from '../data';
import { Transaction } from '../transaction/transaction';

@Injectable()
export class StreetTypeProvider {
    constructor(private streetTypeApiRepository: StreetTypeApiRepository, private streetTypeCacheRepository: StreetTypeCacheRepository) {}

    find(): Observable<Transaction<StreetTypeInterface[]>> {
        return concat(
            this.streetTypeCacheRepository.load(),
            this.streetTypeApiRepository.load().pipe(
                tap((transaction) => {
                    if (transaction.isSuccess) {
                        this.streetTypeCacheRepository.save(transaction.data).subscribe();
                    }
                })
            )
        ).pipe(first());
    }
}
